jQuery(document).ready(function($) {
    function show_price(price) {
        var find = money_format.indexOf("{");
        if (find === 0) {
            return price + money_format.substr((money_format.lastIndexOf("}") + 1));
        } else {
            return money_format.substr(0, money_format.indexOf("{")) + price;
        }
    }
    if ($('.wishlist-premium').length > 0) {
        $.ajax({
            url: 'https://wishlist.tubopify.com/wishlist.php',
            type: 'GET',
            data: {
                customer_id: customer_id,
                shop: shop_domain,
                type: 'get'
            },
            dataType: 'json'
        }).always(function(response) {
            var products = response.data;
            $('.wishlist-premium').html('');
            var number = 0;
            var input = '';
            for (var i = 0; i <= products.length; i++) {
                var product_temp = $.parseHTML(wishlist_premium.product_temp);
                var $product_temp = $(product_temp);
                var product = products[i];

                if (typeof product !== "undefined") {
                    number++;
                    var $title = product.title;
                    if ($title.length > (wishlist_premium.name_length - 3)) {
                        $title = $title.substr(0, wishlist_premium.name_length - 3) + ' ...';
                    }
                    var product_type = (product.type == "") ? 'unknown' : product.type;
                    // $product_temp.removeClass('page-1').addClass('page_' + filter.page).addClass(product_type);
                    var title_temp = $product_temp.find('.product-name a');
                    var images = product.images;
                    var variant = product.selected_or_first_available_variant;
                    title_temp.text($title).attr('href', '/products/' + product.handle + '?variant=' + variant.id).attr('title', product.title);
                    $product_temp.find('input[name="id"]').attr('value', variant.id);
                    $product_temp.find('.add_wishlist').attr('data-variant-id', variant.id).html('');
                    input += '<input type="hidden" name="id[]" value="'+variant.id+'">';
                    if (wishlist.indexOf(variant.id.toString()) === -1) {
                        $product_temp.find('.add_wishlist').html('<i class="fa fav-' + variant.id + ' fa-heart-o"></i>');
                    } else {
                        $product_temp.find('.add_wishlist').html('<i class="fa fav-' + variant.id + ' fa-heart"></i>');
                    }
                    $product_temp.find('.product-image').html('');
                    var img_main = product.image.src;
                    var point = img_main.lastIndexOf('.');
                    var img_main_src = [img_main.slice(0, point), '_400x600', img_main.slice(point)].join('');
                    $product_temp.find('.product-image').parents('a').attr('href', '/products/' + product.handle + '?variant=' + variant.id);
                    $product_temp.find('.product-image').append('<img src="' + img_main_src + '" class="img-reponsive" alt="' + product.title + '">');
                    var product_price = $product_temp.find('.product-price');
                    product_price.html('');
                    if (product.compare_at_price_max > product.price) {
                        product_price.append('<span class="no-sale">' + show_price(product.compare_at_price_max) + '</span>');
                    }
                    product_price.append('<span class="price-origin">' + show_price(product.price) + '</span>');
                    $('.wishlist-premium').append($product_temp);
                }
            }
            // console.log(wishlist_premium.notication);
            $('.checkout-wishlist').html(input);
            var notic = wishlist_premium.noti;
            var init = "";
            if (number != 1) {
                init = wishlist_premium.items;
            } else {
                init = wishlist_premium.item;
            }
            notic = notic.replace('[number]', '<strong>'+number + ' '+init+'</strong>');
            $('.wishlist-header h2').html(notic);
        });
    }
    $(document).on('click','.header-add-wishlist-ajax',function(e){
        e.preventDefault();
        var variant_id = $(this).attr('data-variant-id');
        if (customer_id == "") {
            return;
        }
        var data = {
            customer_id: customer_id,
            variant_id: variant_id,
            type: 'update',
            shop: shop_domain
        };
        $.ajax({
            url: 'https://wishlist.tubopify.com/wishlist.php',
            type: 'POST',
            data: data,
            dataType: 'json'
        }).always(function(response) {
            if (response.message == "success") {
                if (response.type == "add") {
                    window.location = window.location+"pages/wishlist";
                }
                if (response.type == "remove") {
                    alert("Removed from wishlist !");
                }
            }
        });
    });
    $(document).on('click', '.wishlist-btn', function(e) {
        e.preventDefault();
        var that = this;
        var variant_id = $(this).attr('data-variant-id');
        var this_id = 'fav-' + variant_id;
        if (customer_id == "") {
            return;
        }
        var data = {
            customer_id: customer_id,
            variant_id: variant_id,
            type: 'update',
            shop: shop_domain
        };
        $.ajax({
            url: 'https://wishlist.tubopify.com/wishlist.php',
            type: 'POST',
            data: data,
            dataType: 'json'
        }).always(function(response) {
            if (response.message == "success") {
                if (response.type == "add") {
                    var alert = $(that).parents('.item-add').find('.wishlist-alert');
                    alert.addClass('add-success');
                    if ($('.' + this_id).hasClass('fa-heart-o')) {
                        $('.' + this_id).removeClass('fa-heart-o').addClass('fa-heart');
                    } else {
                        $('.' + this_id).removeClass('fa-heart').addClass('fa-heart-o');
                    }
                    setTimeout(function() {
                        alert.removeClass('add-success');
                    }, 2000);
                }
                if (response.type == "remove") {
                    $('.' + this_id).removeClass('fa-heart').addClass('fa-heart-o');
                }
            }
        });
    });
    $(document).on('click', 'a.clear-wishlist', function(e) {
        e.preventDefault();
        var that = this;
        var data = {
            customer_id: customer_id,
            type: 'delete-all',
            shop: shop_domain
        };
        var wishlist_items = $('.wishlist-premium');
        $.ajax({
            url: 'https://wishlist.tubopify.com/wishlist.php',
            type: 'POST',
            data: data,
            dataType: 'json'
        }).always(function(response) {
            if (response.message == "success") {
                wishlist_items.html('');
                $('.wishlist-header .size').text('0');
            }
        });
    });
});